import React, { useState, useMemo } from "react";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useLocation, useHistory } from "react-router";
import CreateCommonCostsForm from "./CreateCommonCostsForm";
import { fetchProviders } from "../../helpers/api/provider";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { fetchCreateCommonCost } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { fetchProperties } from "../../helpers/api/condominium";
import { formatDate } from "../../helpers/utils";
import { format } from "prettier";
import moment from "moment";
import CreateIndividualCostsForm from "./CreateIndividualCostsForm";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateIndividualCosts = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { state } = useLocation();
  const history = useHistory();

  const [propertySearch, setPropertySearch] = useState("");
  const params = useMemo(() => ({
    condominiumId: id || selectedCondominium,
    search: propertySearch,
  }), [id, selectedCondominium, propertySearch]);
  const providerParams = useMemo(() => ({
    condominiumId: id || selectedCondominium,
  }), [id, selectedCondominium]);

  const propertiesResponse = useSWRFetchPagination(fetchProperties, params);
  const providersResponse = useSWRFetchPagination(
    fetchProviders,
    providerParams,
    null,
    1,
    100
  );
  const {
    mutate,
    data,
    isLoading,
    meta,
    handler
  } = propertiesResponse;


  const create = async (values) => {
    if (!state?.type_id) {
      return Toast.fire({
        type: "error",
        title: "No se ha podido crear el tipo de gasto comun",
      });
    }

    try {
      const { code } = await fetchCreateCommonCost(
        id || selectedCondominium,
        {
          ...values,
          // La tasa la decide el formulario según la fecha del gasto. Si no
          // pudo resolverla va vacía y la completa el backend: mandar la del
          // día (activeExchangeRate) guardaría una tasa que no es la del gasto.
          rate: values.rate || null,
          type_id: state.type_id,
        }
      );
      if (code === SUCCESS_RESPONSE.OK) {
        history.push({
          pathname: `/dashboard/${moduleBase}/${id}/individual-costs`,
          state: {
            type_id: state.type_id,
            type_name: state.type_name,
          },
        });

        Toast.fire({
          type: "success",
          title: `Gasto común registrado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title={state?.type_name || "Crear Gasto Individual"}
        titleTag="h2"
        description="Asigna un gasto particular a un propietario."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState loading={isLoading} overlay>
        <CreateIndividualCostsForm
          handleSubmitData={create}
          mutate={mutate}
          handler={handler}
          handlerM={handler}
          providers={providersResponse.data}
          mutateProviders={providersResponse.mutate}
          metaa={meta}
          properties={data}
          setParams={setPropertySearch} />

      </PreloadState>
    </>
  );
};

export default withRedirect(CreateIndividualCosts);
